import { jwtDecode } from 'jwt-decode';

import { getToken } from 'utils/localStorage';
import { refreshToken } from 'models/auth/auth.queries';

let refreshTimer: number;

export const stopRefresh = (): void => {
  clearTimeout(refreshTimer);
}

export const initRefresh = (): void => {
  stopRefresh();

  const now = Date.now();
  const accessToken = getToken();
  if (accessToken) {
    try {
      const decoded = jwtDecode(accessToken);
      const expiration = (decoded.exp ?? 1) * 1000;
      const timeLeft = expiration - now;
      // We will refresh the token when there is just 1 minute left to expire
      const timeFrame = 60 * 1000;
      const delay = Math.max(timeLeft - timeFrame, 0);
      
      // Related issue for long timers: https://github.com/facebook/react-native/issues/12981
      refreshTimer = setTimeout(refreshToken, delay, false);
    }
    catch (error) {
      // invalid token format
      // in case of incorrect token jwtDecode will crash, the user will be able to use the platform anyways as long as the accesToken is usable
    }
  }
}